import React from "react";
import echarts from "echarts";

class Series extends React.Component {
  componentDidMount() {
    this.myChart = echarts.init(document.getElementById("echarts"));
    this.drawChart(this.props);
    window.addEventListener("resize", () => {
      this.myChart.resize();
    });
  }

  componentWillReceiveProps(nextProps) {
    this.drawChart(nextProps);
  }

  drawChart = params => {
    const { legend, title, xAxisData, series } = params;
    this.myChart.setOption({
      title: {
        text: title,
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        data: legend,
      },
      xAxis: {
        data: xAxisData,
      },
      yAxis: {},
      series,
      dataZoom: [
        {
          type: "slider",
          show: true,
        },
      ],
    });
    this.myChart.resize();
  };

  render() {
    return <div id="echarts" style={{ width: "100%", height: 600 }} />;
  }
}

export default Series;



// WEBPACK FOOTER //
// ./src/components/comm/charts/Line2/Index.js